module.exports = ".tspan{\r\n    color: #333333;\r\n    font-size: 18px;\r\n    fill: #333333;\r\n    font-weight: 500;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/pie-chart/pie-chart.component.css
// module id = ./src/app/modules/dashboard/pie-chart/pie-chart.component.css
// module chunks = main